// src/services/prescriptionsApi.js
import api from './api'; // cliente central com baseURL + interceptors

// ---------- Templates ----------
export async function listTemplates() {
  const { data } = await api.get('/prescriptions/templates');
  return data?.items || data || [];
}

export async function createTemplate(payload) {
  const { data } = await api.post('/prescriptions/templates', payload);
  return data;
}

export async function updateTemplate(id, payload) {
  const { data } = await api.put(`/prescriptions/templates/${id}`, payload);
  return data;
}

export async function deleteTemplate(id) {
  const { data } = await api.delete(`/prescriptions/templates/${id}`);
  return data;
}

/**
 * Configura templates/padrões iniciais de receituários/atestados no backend.
 * Esse é o nome que o resto do frontend espera: setupDefaultTemplates.
 */
export async function setupDefaultTemplates() {
  const { data } = await api.post('/prescriptions/setup-defaults');
  return data;
}

// Mantemos também o alias setupDefaults, caso em algum lugar esteja usando esse nome.
export const setupDefaults = setupDefaultTemplates;

// ---------- Documents (receituários, atestados, etc.) ----------
export async function listDocuments(params) {
  let url = '/prescriptions/documents';
  if (params && typeof params === 'object') {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        search.append(key, value);
      }
    });
    const qs = search.toString();
    if (qs) url += `?${qs}`;
  }
  const { data } = await api.get(url);
  return data?.items || data || [];
}

export async function createDocument(payload) {
  const { data } = await api.post('/prescriptions/documents', payload);
  return data;
}

export async function updateDocument(id, payload) {
  const { data } = await api.put(`/prescriptions/documents/${id}`, payload);
  return data;
}

export async function deleteDocument(id) {
  const { data } = await api.delete(`/prescriptions/documents/${id}`);
  return data;
}

export async function getDocument(id) {
  const { data } = await api.get(`/prescriptions/documents/${id}`);
  return data;
}

// ---------- History ----------
export async function getHistory(limit = 50, offset = 0, patientId = null) {
  const params = { limit, offset };
  if (patientId) params.patient_id = patientId;
  const { data } = await api.get('/prescriptions/history', { params });
  return data?.documents || data || [];
}

// ---------- Branding ----------
export async function getBranding(professionalId = null) {
  let url = '/prescriptions/branding';
  if (professionalId) {
    url += `?professional_id=${professionalId}`;
  }
  const { data } = await api.get(url);
  return data || null;
}

export async function updateBranding(payload) {
  const { data } = await api.put('/prescriptions/branding', payload);
  return data;
}

// ---------- Auxiliares ----------
export async function listPatients(limit = 100) {
  const { data } = await api.get(`/patients?limit=${limit}`);
  return data?.items || data || [];
}

export async function getStats() {
  const { data } = await api.get('/prescriptions/stats');
  return data || null;
}

// Envio por e-mail (endpoint unificado de documentos)
export async function sendDocumentEmail(payload) {
  // backend expõe /documents/send-email e /api/documents/send-email
  const { data } = await api.post('/documents/send-email', payload);
  return data;
}

export async function getProfessionals() {
  const { data } = await api.get('/clinic-settings');
  return data?.professionals || [];
}
